import { useParams } from 'react-router';

import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';

export function useEmbedSearchWidgetIdParam() {
  const params = useParams();

  return {
    // All embed widget routes have a `embedSearchWidgetId` param
    embedSearchWidgetId: params.embedSearchWidgetId as
      | ApiEmbedSearchWidgetId
      | undefined,
  };
}
